import { createFileRoute } from '@tanstack/react-router'
import { CreatePetPage } from '_/features/pets/ui/pages/create-pet-page'

export const Route = createFileRoute('/_authenticated/pets/create')({
	staticData: { title: 'pets_create_title' },
	component: CreatePetPage,
})
